import React from "react";
import styled from "styled-components";
import { Colors } from "../../../utils/colors/colors";
import EventDetails from "./EventDetails";
import { resumeClinicDetailsData } from "../../../assets/data/event-rsvp/resumeClinicData"
import { eventSpeakersData } from "../../../assets/data/event-page/eventPageData";
import SpeakerCard from "../../events/open-forum-events/SpeakerCard";




export default function ResumeClinicDetails() {


  const { primaryColor, secondaryColor } = Colors();
  const { subtitle, time, title, description, currentEventDate, flyerUrl, venue } = resumeClinicDetailsData();
  return (
    <EventDetailsWrapper>
      <EventHighlight>
        <Text
          data-aos-once="true"
          data-aos="fade-up"
          style={{
            color: secondaryColor,
          }}
        >
          {subtitle}
        </Text>
        <EventTitleText
          data-aos-once="true"
          data-aos="fade-up"
          style={{
            color: primaryColor,
          }}
        >
          {title}
        </EventTitleText>
      </EventHighlight>

      <EventDetails time={time} date={currentEventDate}  venue={venue} />

      <AboutEventWrapper>
        <AboutEventWrapper>
          <Text>About Event</Text>
          <AboutEventText
            data-aos-once="true"
            data-aos="fade-up"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </AboutEventWrapper>
      </AboutEventWrapper>



      <SpeakerDetailsWrapper>
        <SpeakerText>Speaker/Moderator(s)</SpeakerText>
        <SpeakersWrapper>
          {eventSpeakersData.map((speakers) => (
            <SpeakerCard {...speakers} key={speakers.id} />
          ))}
        </SpeakersWrapper>
      </SpeakerDetailsWrapper>
    </EventDetailsWrapper>
  );
}

const EventDetailsWrapper = styled.div``;

const EventHighlight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
`;

const Text = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  text-transform: uppercase;
  color: #fc8212;

  @media (min-width: 476px) {
    font-size: 21px;
  }
`;

const EventTitleText = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 120%;
  display: flex;
  align-items: center;
  text-transform: uppercase;

  @media (min-width: 476px) {
    font-size: 52px;
  }
`;

const AboutEventWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 40px;
`;

const AboutEventText = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 200%;
  color: #303030;
  opacity: 0.9;
`;

const SpeakersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
`;
const SpeakerText = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 900;
  font-size: 18px;
  line-height: 200%;
  color: #fc8212;
  opacity: 0.9;
  padding: 0px;
  margin: 0;
`;

const SpeakerDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 10px;
  margin-top: 40px;
`;
